module.exports = __webpack_public_path__ + "static/media/magic-protection.84829c92.png";